// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ge-0";
export var fileList = "_ge-2";
export var removeFileButton = "_ge-1";